import { DialogWrapper } from 'Dialogs/wrapper';
import html from './template.html';
import './style.less';

class UserAreasSelectedSidesheet extends DialogWrapper {
  constructor(params = {}, element) {
    super(params, element);

    this.question = params.question;
    this.answer = params.answer;

    this.enableAreas = ko.observable(false)
    
    this.imageSrc = ko.observable(ko.unwrap(this.question?.imageSrc) || ko.unwrap(this.question?.imageUrl));
    this.imageWidth = ko.observable(0);
    this.imageHeight = ko.observable(0);

    this.areas = ko.observableArray(this.prepareAreasData());
    this.firstClickArea = ko.observableArray(this.changingFormat(params.firstClickArea))

    this.originalImageDimensions = ko.observable({ width: 0, height: 0 });

    if (this.imageSrc()) {
      this.loadImageDimensions(this.imageSrc()).then((dimensions) => {
        this.imageWidth(dimensions.width);
        this.imageHeight(dimensions.height);
        this.originalImageDimensions({
          width: dimensions.width,
          height: dimensions.height
        });
        this.areas(this.prepareAreasData());
        this.firstClickArea(this.changingFormat(params.firstClickArea))
      });
    }
  }

  loadImageDimensions(url) {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = () => {
        resolve({
          width: img.naturalWidth,
          height: img.naturalHeight
        });
      };
      img.onerror = () => {
        console.error('Error loading image for dimension check');
        resolve({ width: 0, height: 0 });
      };
      img.src = url;
    });
  }

  prepareAreasData() {
    if (!this.answer || !this.answer.areasSelected) return [];

    const imageWidth = this.imageWidth() || 1;
    const imageHeight = this.imageHeight() || 1;

    return ko.unwrap(this.answer.areasSelected).map(area => {
      return {
        id: area.id,
        name: ko.observable(area.name || `Выбранная область ${area.id}`),
        x: ko.observable(area.x / imageWidth),
        y: ko.observable(area.y / imageHeight),
        width: ko.observable(area.width / imageWidth),
        height: ko.observable(area.height / imageHeight),
        clickTime: ko.observable(area.clickTime || 0),
        matchedAreas: ko.observable(area.matchedAreas || []),
        hovered: ko.observable(false)
      };
    });
  }

  changingFormat(areas) {
    if(!areas) return []
    const imageWidth = this.imageWidth() || 1;
    const imageHeight = this.imageHeight() || 1;

    return ko.unwrap(areas).map(area => {
      return {
        id: area.id,
        name: ko.observable(area.name),
        x: ko.observable(area.x_coord / imageWidth),
        y: ko.observable(area.y_coord / imageHeight),
        width: ko.observable(area.width / imageWidth),
        height: ko.observable(area.height / imageHeight),
        hovered: ko.observable(false)
      };
    })
  }

  onModalInit(...args) {
    super.onModalInit(...args);
  }
}

ko.components.register('user-areas-selected-sidesheet', {
  viewModel: {
    createViewModel: (params, componentInfo) => {
      const element = componentInfo.element;
      element.classList.add('user-areas-selected-sidesheet');
      return new UserAreasSelectedSidesheet(params, element);
    },
  },
  template: html,
});

export default UserAreasSelectedSidesheet;
